import { style } from "@mui/system";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import "../Main.scss";
import "./my.scss";
import "../../lib/form/form.scss";
import {
  MdHomeFilled,
  MdKeyboardArrowRight,
  MdKeyboardArrowLeft,
} from "react-icons/md";
import { MdClose } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import ConfirmModal from "../../components/ConfirmModal";
import PwdModal from "../../components/PwdModal";
import Post from "../../utils/postUtil";
import Swal from "sweetalert2";

// import "../lib/modal/modal.scss";

const MyCommittee = () => {
  let navigate = useNavigate();

  // 토큰, decode id
  const token = window.sessionStorage.getItem("token");
  const id = jwtDecode(token).sub;

  // 비밀번호 변경
  const [oldWords, setOldWords] = useState("");
  const [newWords, setNewWords] = useState("");
  const [checkNewWords, setCheckNewWords] = useState("");
  const [pwdErrorMsg, setPwdErrorMsg] = useState(false);

  // 비밀번호 변경 함수
  const changePwd = async () => {
    // if (checkNewWords !== newWords) {
    //   alert("비밀번호가 일치하지 않습니다.");
    // }
    if (checkNewWords === newWords) {
      const params = new URLSearchParams();
      params.append("oldWords", oldWords);
      params.append("newWords", newWords);
      try {
        const response = await axios.patch(
          `/api/committee-member/${id}/change-password`,
          params,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        setPwdShowModal(false);
        navigate("/");
        Swal.fire("성공!", "비밀번호 변경 완료", "success");
      } catch (error) {
        console.log(error);
        if (error.response.status === 401) {
          setPwdErrorMsg(true);
        }
        console.log(error);
      }
    }
  };
  const onChangeHandler = (e) => {
    if (e.target.name === "oldWords") {
      setOldWords(e.target.value);
    }
    if (e.target.name === "newWords") {
      setNewWords(e.target.value);
    }
    if (e.target.name === "checkNewWords") {
      setCheckNewWords(e.target.value);
    }
  };

  // 위원회 마이페이지 상세정보
  const [dataLookup, setDataLookup] = useState([]);
  const [postNum, setPostNum] = useState("");
  const [address, setAddress] = useState("");

  // 위원회 마이페이지 수정
  const [inputDisable, setInputDisable] = useState(true);
  const [buttonType, setButtonType] = useState("Modify");
  const onClickModify = async () => {
    setInputDisable(false);
    setButtonType("Save");
  };

  // 위원회 마이페이지 저장
  const onClickSave = async () => {
    if (buttonType !== "Modify") {
      await axios
        .patch(
          `/api/committee-member/${id}`,
          {
            postNum: postNum,
            address1: address,
            address2: dataLookup.address2,
            email: dataLookup.email,
            id: dataLookup.id,
            name: dataLookup.name,
            organization: dataLookup.organization,
            position: dataLookup.position,
            telNum: dataLookup.telNum,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          doneModal();
        })
        .catch((error) => {
          console.log(error);
        });
    }
    setInputDisable(true);
    setButtonType("Modify");
  };

  // 위원회 마이페이지 회원탈퇴
  const quitMemeber = async () => {
    try {
      const response = await axios.delete(`/api/committee-member/${id}`);
      window.sessionStorage.removeItem("token");
      navigate("/");
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  // 우편번호 검색
  const [enroll_company, setEnroll_company] = useState({
    zonecode: "",
    address: "",
  });
  const handleInput = (e) => {
    setEnroll_company({
      ...enroll_company,
      [e.target.name]: e.target.value,
    });

    setPostNum(enroll_company.zonecode);
    setAddress(enroll_company.address);
  };

  // 모달 상태관리
  const [showModal, setShowModal] = useState(false);
  const [pwdShowModal, setPwdShowModal] = useState(false);
  const [modifyShowModal, setModifyShowModal] = useState(false);
  const [doneShowModal, setDoneModal] = useState(false);
  const [postShowModal, setPostShowModal] = useState(false);
  const [withdrawalShowModal, setWithdrawalShowModal] = useState(false);
  const [companyUploadShowModal, setCompanyUploadShowModal] = useState(false);

  // 모달 함수
  const openModal = () => {
    setPwdShowModal(true);
  };
  const closeModal = () => {
    setPwdShowModal(false);
  };
  const modifyModal = () => {
    setModifyShowModal(true);
  };
  const closeModifyModal = () => {
    setModifyShowModal(false);
  };
  const doneModal = () => {
    setDoneModal(true);
  };
  const closeDoneModal = () => {
    setDoneModal(false);
  };
  const handleComplete = () => {
    setPostShowModal(!postShowModal);
  };
  const withdrawalModal = () => {
    setWithdrawalShowModal(true);
  };
  const closeWithdrawalModal = () => {
    setWithdrawalShowModal(false);
  };

  // 위원회 마이페이지 조회
  useEffect(() => {
    axios
      .get(`/api/committee-member/${id}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setDataLookup(response.data);
        setPostNum(response.data.postNum);
        setAddress(response.data.address1);
      })
      .catch((error) => {
        console.log(error);
        console.log(error);
      });
  }, []);

  // 마이페이지 입력값 핸들러
  const onChangeDetailAddress = ({ target: { value } }) => {
    dataLookup.address2 = value;
  };
  const onChangeAddress = ({ target: { value } }) => {
    dataLookup.address1 = value;
  };
  const onChangeOrganization = ({ target: { value } }) => {
    dataLookup.organization = value;
  };
  const onChangeName = ({ target: { value } }) => {
    dataLookup.name = value;
  };
  const onChangePosition = ({ target: { value } }) => {
    dataLookup.position = value;
  };
  const onChangeTelNum = ({ target: { value } }) => {
    dataLookup.telNum = value;
  };
  const onChangeEmail = ({ target: { value } }) => {
    dataLookup.email = value;
  };

  // console.log(dataLookup.committees.length);
  // console.log(dataLookup.committees);

  return (
    <>
      {withdrawalShowModal ? (
        <div className="popup_bg_bbs " onClick={withdrawalModal}>
          <div
            className="password_change "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>회원탈퇴</h1>
            </div>
            <div className="password_change_inner">
              진행하시겠습니까?
              <div className="btns_wrap">
                <button className="btn_color" onClick={closeWithdrawalModal}>
                  <span className="material-icons">취소</span>
                </button>
                <button onClick={quitMemeber} className="btn_color">
                  <span className="material-icons">탈퇴</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {postShowModal ? (
        <div className="popup_bg_bbs" onClick={handleComplete}>
          <div className="popup_bbs">
            {/* <span className='close_btn' onClick={closeModal}><MdClose /></span> */}
            {
              <Post
                company={enroll_company}
                setcompany={setEnroll_company}
                showmodal={setPostShowModal}
                setPostNum={setPostNum}
                setAddress1={setAddress}
              ></Post>
            }
          </div>
        </div>
      ) : null}
      {pwdShowModal ? (
        <PwdModal
          closeModal={closeModal}
          onChangeHandler={onChangeHandler}
          changePwd={changePwd}
          pwdErrorMsg={pwdErrorMsg}
        />
      ) : null}
      {modifyShowModal ? (
        <ConfirmModal
          closeModal={closeModifyModal}
          modalTitle={"수정 가능"}
          content={"정보 수정이 가능합니다."}
        />
      ) : null}
      {doneShowModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"저장 완료"}
          content={"정보 저장이 완료되었습니다."}
        />
      ) : null}

      <div className="contain my_wrap">
        <form className="my_page" action="" method="">
          <div className="row">
            <div className="col">
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="id">아이디</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: "#eee",
                      }}
                      id="id"
                      className="input_line"
                      type="text"
                      placeholder="아이디"
                      defaultValue={dataLookup.id}
                      disabled
                    />
                    {inputDisable ? (
                      <button
                        className="btn_none"
                        onClick={(e) => {
                          e.preventDefault();
                          openModal();
                        }}
                        disabled={inputDisable}
                      >
                        비밀번호변경
                      </button>
                    ) : (
                      <button
                        className="btn_color"
                        onClick={(e) => {
                          e.preventDefault();
                          openModal();
                        }}
                        disabled={inputDisable}
                      >
                        비밀번호변경
                      </button>
                    )}
                  </div>
                </div>
                <div className="input_col"></div>
              </div>
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="organization">소속 / 회사</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="organization"
                      className="input_line"
                      type="text"
                      placeholder="소속 / 회사"
                      defaultValue={dataLookup.organization}
                      disabled={inputDisable}
                      onChange={onChangeOrganization}
                    />
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="name">이름</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="name"
                      className="input_line"
                      type="text"
                      placeholder="이름"
                      defaultValue={dataLookup.name}
                      disabled={inputDisable}
                      onChange={onChangeName}
                    />
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="position">직책</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="position"
                      className="input_line"
                      type="text"
                      placeholder="직책"
                      defaultValue={dataLookup.position}
                      disabled={inputDisable}
                      onChange={onChangePosition}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="input_row">
                <div className="input_col"></div>
              </div>
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="bus_num">연락처</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="bus_num"
                      className="input_line"
                      type="tel"
                      placeholder="-없이"
                      defaultValue={dataLookup.telNum}
                      disabled={inputDisable}
                      onChange={onChangeTelNum}
                    />
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="email">이메일</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="email"
                      className="input_line"
                      type="email"
                      placeholder="abc@co.kr"
                      defaultValue={dataLookup.email}
                      disabled={inputDisable}
                      onChange={onChangeEmail}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="id">우편번호</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="id"
                      className="input_line"
                      type="text"
                      placeholder="우편번호"
                      defaultValue={postNum}
                      disabled={inputDisable}
                      onChange={handleInput}
                      onClick={(e) => {
                        e.preventDefault();
                        handleComplete();
                      }}
                      readOnly
                    />
                    {inputDisable ? (
                      <button
                        className="btn_none"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          handleComplete();
                        }}
                        disabled={inputDisable}
                      >
                        주소검색
                      </button>
                    ) : (
                      <button
                        className="btn_color"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          handleComplete();
                        }}
                        disabled={inputDisable}
                      >
                        주소검색
                      </button>
                    )}
                  </div>
                </div>
                <div className="input_col"></div>
              </div>
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="bus_num">주소</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="bus_num"
                      className="input_line"
                      type="text"
                      placeholder="도로명주소"
                      defaultValue={address}
                      disabled={inputDisable}
                      onChange={onChangeAddress}
                      onClick={(e) => {
                        e.preventDefault();
                        handleComplete();
                      }}
                      readOnly
                    />
                    {/* <button className="btn_color">버튼</button> */}
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="co_name">상세주소</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_name"
                      className="input_line"
                      type="text"
                      placeholder="상세주소"
                      defaultValue={dataLookup.address2}
                      disabled={inputDisable}
                      onChange={onChangeDetailAddress}
                    />
                    {/* <button className="btn_color">버튼</button> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col" style={{ paddingBottom: "2rem" }}>
              <div className="row_bbs">
                <table className="table_wrap">
                  <thead>
                    <tr>
                      <th>이름</th>
                      <th>역할</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {dataLookup.committees &&
                        dataLookup.committees.length === 0 &&
                        "위원회 목록이 존재하지 않습니다."}
                    </tr>
                    {dataLookup.committees &&
                      dataLookup.committees.map((value) => {
                        return (
                          <tr key={value.id}>
                            <td className="">{value.name}</td>
                            <td>
                              {value.captainId === dataLookup.id
                                ? "위원장"
                                : null}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="input_wrap submit_btn">
              <button
                type="button"
                className="btn_none"
                onClick={withdrawalModal}
              >
                탈퇴
              </button>
              {buttonType === "Modify" ? (
                <>
                  <button
                    type="button"
                    className="btn_color"
                    onClick={(e) => {
                      e.preventDefault();
                      onClickModify();
                      modifyModal();
                    }}
                  >
                    수정
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  className="btn_color"
                  onClick={(e) => {
                    e.preventDefault();
                    onClickSave();
                    doneModal();
                  }}
                >
                  저장
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default MyCommittee;
